import { Fragment } from 'react'

import { RequestProfileWidgetKey } from '../RequestProfileWidget.constants'
import { RequestProfileWidgetAddress } from '../RequestProfileWidgetAddress'
import { RequestProfileWidgetAISummary } from '../RequestProfileWidgetAISummary'
import { RequestProfileWidgetBudgetPlan } from '../RequestProfileWidgetBudgetPlan'
import { RequestProfileWidgetBuildingGroups } from '../RequestProfileWidgetBuildingGroups'
import { RequestProfileWidgetCreated } from '../RequestProfileWidgetCreated'
import { RequestProfileWidgetDwellersAndLandlords } from '../RequestProfileWidgetDwellersAndLandlords'
import { RequestProfileWidgetFinished } from '../RequestProfileWidgetFinished'
import { RequestProfileWidgetLabels } from '../RequestProfileWidgetLabels'
import { RequestProfileWidgetProviders } from '../RequestProfileWidgetProviders'
import { RequestProfileWidgetResponsibleManagers } from '../RequestProfileWidgetResponsibleManagers'
import { RequestProfileWidgetSideWorkers } from '../RequestProfileWidgetSideWorkers'
import { RequestProfileWidgetTimeTracking } from '../RequestProfileWidgetTimeTracking'

export function getRequestProfileOrderedWidgets({
  widgetListOrder,
  widgetsByKey,
}) {
  return widgetListOrder
    .map(widgetKey => {
      const widget = widgetsByKey[widgetKey]

      return widget ? <Fragment key={widgetKey}>{widget}</Fragment> : null
    })
    .filter(Boolean)
}

export function getRequestProfileWidgetsByKey({
  aiFeatures,
  isHeaderGroupLayout,
  isSkeleton,
  outboundUuid,
  requestData,
  requestProvidersPermissions,
}) {
  const permissions = requestData?.permissions

  const canViewProviders = outboundUuid
    ? requestProvidersPermissions?.can_view_contractors
    : permissions?.can_view_contractors ||
      permissions?.can_view_recommended_contractors

  return {
    [RequestProfileWidgetKey.ADDRESS]:
      isSkeleton || requestData?.building ? (
        <RequestProfileWidgetAddress
          isSkeleton={isSkeleton}
          requestData={requestData}
        />
      ) : null,
    [RequestProfileWidgetKey.AI_SUMMARY]:
      !isHeaderGroupLayout &&
      !outboundUuid &&
      aiFeatures?.request_summary_generation ? (
        <RequestProfileWidgetAISummary
          isSkeleton={isSkeleton}
          requestData={requestData}
        />
      ) : null,
    [RequestProfileWidgetKey.ASSIGNEES]: permissions?.can_view_assignee ? (
      <RequestProfileWidgetResponsibleManagers isSkeleton={isSkeleton} />
    ) : null,
    [RequestProfileWidgetKey.BUDGET_PLAN]:
      requestData?.budgetPlan || permissions?.can_view_budget_plan ? (
        <RequestProfileWidgetBudgetPlan
          isSkeleton={isSkeleton}
          requestData={requestData}
        />
      ) : null,
    [RequestProfileWidgetKey.BUILDING_GROUPS]:
      requestData?.buildingGroups?.length > 0 ? (
        <RequestProfileWidgetBuildingGroups
          buildingGroups={requestData?.buildingGroups}
          isSkeleton={isSkeleton}
        />
      ) : null,
    [RequestProfileWidgetKey.CREATED]: (
      <RequestProfileWidgetCreated
        isSkeleton={isSkeleton}
        requestData={requestData}
      />
    ),
    [RequestProfileWidgetKey.FINISHED]:
      isSkeleton || requestData?.finishedAt ? (
        <RequestProfileWidgetFinished isSkeleton={isSkeleton} />
      ) : null,
    [RequestProfileWidgetKey.INHABITANTS]: (
      <RequestProfileWidgetDwellersAndLandlords
        isSkeleton={isSkeleton}
        requestData={requestData}
      />
    ),
    [RequestProfileWidgetKey.LABELS]:
      requestData?.labels?.length > 0 || permissions?.can_edit_labels ? (
        <RequestProfileWidgetLabels isSkeleton={isSkeleton} />
      ) : null,
    [RequestProfileWidgetKey.PROVIDERS]: canViewProviders ? (
      <RequestProfileWidgetProviders isSkeleton={isSkeleton} />
    ) : null,
    [RequestProfileWidgetKey.SIDE_WORKERS]: permissions?.can_view_workers ? (
      <RequestProfileWidgetSideWorkers isSkeleton={isSkeleton} />
    ) : null,
    [RequestProfileWidgetKey.TIME_TRACKING]:
      permissions?.can_view_completion_time ? (
        <RequestProfileWidgetTimeTracking
          completionTime={requestData?.completionTime}
          isSkeleton={isSkeleton}
        />
      ) : null,
  }
}
